import React from 'react';
import './week-calendar-header.css';
import WeekCalendarHeaderCell from './week-calendar-header-cell';

const DAYS = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];

const WeekCalendarHeader = ({ ...props }) => {
    const { startDate, compact, dayPos, setDayPos } = props;

    return (
        <div className={`week-calendar-header${compact ? ' week-calendar-header--compact' : ''}`}>
            {compact ? null : (
                <WeekCalendarHeaderCell className='week-calendar-header-cell--time' />
            )}
            {DAYS.map((day, index) => (
                <WeekCalendarHeaderCell
                    key={day}
                    compact={compact}
                    selected={dayPos === index}
                    index={index}
                    setDayPos={setDayPos}
                >
                    {day} {startDate.add(index, 'd').format('DD.MM')}
                </WeekCalendarHeaderCell>
            ))}
        </div>
    );
};

export default WeekCalendarHeader;
